module.exports = __webpack_public_path__ + "amelia.png?2efa965d5d56f49f28286d645ddcf0fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/amelia.png
// module id = 86
// module chunks = 0